var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","data-test":"results-page"}},[_c('portal',{attrs:{"to":"toolbar"}},[_c('v-toolbar-title',[_vm._v("CBR Availability")])],1),_c('v-card',[_c('list',{attrs:{"dates":_vm.dates,"headers":_vm.headers,"list":_vm.list,"cities":_vm.courseCities,"loading":_vm.loading},on:{"importClicked":_vm.importAccounts}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }